/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { useState } from "react";
import "./friendsCard.scss";
import  DefaultHearder  from "@/app/csr-src/assets/icons/default-avatar.svg";
import UKImg from "@/common-components-src/components/UKImg";

export default function FriendsCard({ data, status }: any) {
  const [showError, setShowError] = useState(false);
  const handleImgError = () => {
    setShowError(true);
  };
  return (
    <div className="groupWrapItem">
      {data.avatar ? (
        // <Image className="flag" src={data.avatar} alt="flag" />
        // <img src={data.avatar} alt="flag" className="avatar_img" onError={handleImgError} />
        <div className="avatar_img">
          <UKImg
            url={data.avatar}
            urlExtend={{
              imgKey: data.avatar ? data.avatar : "",
              width: 50,
              height: 50,
            }}
          />
        </div>
      ) : (
        <div className="avatar_img">
          <DefaultHearder className="headerIcon" />
        </div>
      )}

      <p className="name">{data.nickName}</p>
      <p className="result">{status === "SUCCESS" ? "Ordered" : "Registered"}</p>
      <p className="time">{data.actionTimeStr}</p>
    </div>
  );
}
